import { createBrowserRouter } from "react-router-dom";
import { DashboardView } from "../../pages/dashboard";
import { PageNotFound } from "../../pages/pageNotFound";
import { CartellaAziendale } from "../../pages/cartellaAziendale";
import { ComplianceRequests } from "../../pages/gestioneCertificazione/complianceRequests";
import { AddComplianceRequest } from "../../pages/gestioneCertificazione/complianceRequests/add";
import { EditRequestComplianceRequest } from "../../pages/gestioneCertificazione/complianceRequests/edit";
import { RegistriAziendali } from "../../pages/gestioneClienti/registriAziendali";
import { AddRegistroAziendale } from "../../pages/gestioneClienti/registriAziendali/add";
import { EditRegistroAziendale } from "../../pages/gestioneClienti/registriAziendali/edit";
import { ReportRegistriAziendali } from "../../pages/gestioneClienti/registriAziendali/report";
import { RID } from "../../pages/gestioneClienti/RID";
import { AddRID } from "../../pages/gestioneClienti/RID/addRID";
import { EditRID } from "../../pages/gestioneClienti/RID/editRID";
import { Segnalazioni } from "../../pages/gestioneControllo/segnalazioni";
import { AddReporting } from "../../pages/gestioneControllo/segnalazioni/addReporting";
import { GestionePrelieviForAll } from "../../pages/gestionePrelievi";
import { CustomerMeasueres } from "../../pages/gestioneProvvedimenti/measures";
import { AddNewCodexMeasureStep1 } from "../../pages/gestioneProvvedimenti/measures/addNew/Step1";
import { AddNewCodexMeasureStep2 } from "../../pages/gestioneProvvedimenti/measures/addNew/Step2";
import { EditCodexMeasure } from "../../pages/gestioneProvvedimenti/measures/edit";
import { AddNewCodexMeasureOtherOdc } from "../../pages/gestioneProvvedimenti/measuresOtherOdc/add";
import { EditCodexMeasureOtherOdc } from "../../pages/gestioneProvvedimenti/measuresOtherOdc/edit";
import { AddReinforcedControlMeasure } from "../../pages/gestioneProvvedimenti/reinforcedControlMeasure/add";
import { EditReinforcedControlMeasure } from "../../pages/gestioneProvvedimenti/reinforcedControlMeasure/edit";
import { Notify } from "../../pages/notifiche";
import { NotifyBioEdit } from "../../pages/notifiche/biologica/edit";
import { NotifyGlobalGapEdit } from "../../pages/notifiche/globalGap/edit";
import { NotifySqnpiEdit } from "../../pages/notifiche/prodIntegrata/edit";
import { Incarichi } from "../../pages/incarichi";
import { AddAssignment } from "../../pages/incarichi/addAssignment";
import { EditAssignment } from "../../pages/incarichi/editAssignment";
import { InspectionVisitBlocksEdit } from "../../pages/incarichi/inspectionVisit/edit/blocks";
import { InspectionVisitEdit } from "../../pages/incarichi/inspectionVisit/edit";

const userRouter = createBrowserRouter([
    {
        path: '/',
        element: (<DashboardView />),
    },
    {
        path: '*',
        element: (<PageNotFound />)
    },
    {
        path: '/cartellaAziendale',
        element: (<CartellaAziendale />)
    },
    {
        path: '/segnalazioni',
        element: (<Segnalazioni />)
    },
    {
        path: '/addSegnalazione',
        element: (<AddReporting />)
    },
    {
        path: '/rid',
        element: (<RID />)
    },
    {
        path: '/addRid',
        element: (<AddRID />)
    },
    {
        path: '/editRid',
        element: (<EditRID />)
    },
    {
        path: '/cartellaAziendale',
        element: (<CartellaAziendale />)
    },
    {
        path: '/registriAziendali',
        element: (<RegistriAziendali />)
    },
    {
        path: '/addRegistroAziendale',
        element: (<AddRegistroAziendale />)
    },
    {
        path: '/editRegistroAziendale',
        element: (<EditRegistroAziendale />)
    },
    {
        path: '/reportRegistroAziendale',
        element: (<ReportRegistriAziendali />)
    },
    {
        path: '/gestionePrelieviForAll',
        element: (<GestionePrelieviForAll />)
    },
    {
        path: '/complianceRequests',
        element: (<ComplianceRequests />)
    },
    {
        path: '/addComplianceRequest',
        element: (<AddComplianceRequest />)
    },
    {
        path: '/editComplianceRequest',
        element: (<EditRequestComplianceRequest />)
    },
    {
        path: '/addReinforcedControlMeasure',
        element: (<AddReinforcedControlMeasure />)
    },
    {
        path: '/editReinforcedControlMeasure',
        element: (<EditReinforcedControlMeasure />)
    },
    {
        path: '/provvedimentiCliente',
        element: (<CustomerMeasueres />)
    },
    {
        path: '/editCodexMeasure',
        element: (<EditCodexMeasure />)
    },
    {
        path: '/creaProvvedimentoAltroOdc',
        element: (<AddNewCodexMeasureOtherOdc />)
    },
    {
        path: '/addNewCodexMeasureStep1',
        element: (<AddNewCodexMeasureStep1 />)
    }, 
    {
        path: '/addNewCodexMeasureStep2',
        element: (<AddNewCodexMeasureStep2 />)
    },
    {
        path: '/editProvvedimentoAltroOdc',
        element: (<EditCodexMeasureOtherOdc />)
    },
    {
        path: '/notify',
        element: (<Notify />)
    },
    {
        path: '/notifyBioEdit',
        element: (<NotifyBioEdit />)
    },
    {
        path: '/notifyGlobalGapEdit',
        element: (<NotifyGlobalGapEdit />)
    },
    {
        path: '/notifySqnpiEdit',
        element: (<NotifySqnpiEdit />)
    },
    {
        path: '/incarichi',
        element: (<Incarichi />)
    },
    {
        path: '/inserisciIncarico',
        element: (<AddAssignment />)
    },
    {
        path: '/modificaIncarico',
        element: (<EditAssignment />)
    },
    {
        path: '/ivEdit',
        element: (<InspectionVisitEdit />)
    },
])

export default userRouter;